// Optional Container Trader partner code on the signup forms.
// Filled in automatically from the last ?ref=CODE link used (past 90 days). Unknown codes block
// submit with a message; a failed check never blocks signup.
import React, { useEffect } from 'react';
import { useForm } from 'react-final-form';

import { FieldTextInput } from '../../components';
import {
  getRememberedReferralCode,
  isActiveReferralCode,
  normalizeReferralCode,
} from '../../util/ctReferral';

export const REFERRAL_CODE_FIELD = 'ctReferralCode';

export const validateReferralCode = value => {
  const raw = `${value || ''}`.trim();
  if (!raw) return undefined;
  if (!normalizeReferralCode(raw)) {
    return 'Referral codes use 3 to 24 letters, numbers or dashes.';
  }
  return isActiveReferralCode(raw).then(ok =>
    ok ? undefined : 'We couldn’t find that referral code. Check the spelling or leave it blank.'
  );
};

const FieldReferralCode = ({ className, formId }) => {
  const form = useForm();
  useEffect(() => {
    const remembered = getRememberedReferralCode();
    const current = form.getState().values?.[REFERRAL_CODE_FIELD];
    if (remembered && !current) form.change(REFERRAL_CODE_FIELD, remembered);
  }, [form]);

  return (
    <FieldTextInput
      className={className}
      type="text"
      id={formId ? `${formId}.${REFERRAL_CODE_FIELD}` : REFERRAL_CODE_FIELD}
      name={REFERRAL_CODE_FIELD}
      autoComplete="off"
      label="Referral code (optional)"
      placeholder="For example jake-1a2b"
      maxLength={24}
      validate={validateReferralCode}
    />
  );
};

export default FieldReferralCode;
